import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const inr = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fdate = (d) => {
  if (!d) return "—";
  const dt = new Date(d);
  return dt.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

export const SLAB_LABELS = {
  retail: "Retail (B2C)",
  shopkeeper: "Shopkeeper",
  dealer: "Dealer",
  distributor: "Distributor",
};

export const todayStr = () => new Date().toISOString().slice(0, 10);

// Resolve an FY's [start, end] — explicit dates win, else parsed from the label (Indian FY: Apr–Mar)
export const fyRange = (fy) => {
  if (!fy) return { start: "", end: "" };
  if (fy.start_date && fy.end_date) return { start: fy.start_date, end: fy.end_date };
  const m = (fy.label || "").match(/(\d{4})\s*[-/]?\s*(\d{2,4})?/);
  if (!m) return { start: "", end: "" };
  const y1 = parseInt(m[1], 10);
  let y2 = m[2] ? parseInt(m[2], 10) : (y1 + 1) % 100;
  if (y2 < 100) y2 += Math.floor(y1 / 100) * 100;
  if (y2 <= y1) y2 = y1 + 1;
  return { start: `${y1}-04-01`, end: `${y2}-03-31` };
};
